export default [
  { path: 'mcs/searchdesk/:collection/:id?/:section?', component: () => import('./pages/SearchDesk.vue') }
]
